import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M9.74 47.65C13.87 43.69 11.72 36.75 11.72 36.75C15.02 30.31 11.55 26.84 11.55 26.84C15.68 20.4 11.88 15.61 11.88 15.61C16.17 9.66996 11.71 3.71998 11.71 3.71998C11.71 3.71998 6.7 -0.600015 2.87 3.78998C2.87 3.78998 -1.09 10.08 3.67 15.65C3.67 15.65 0.269999 20.73 4.91 26.82C4.91 26.82 1.74 30.56 5.55 36.71C5.55 36.71 3.97 43.8 8.41 47.41L9.74 47.65Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M39.0399 47.65C34.9099 43.69 37.0599 36.75 37.0599 36.75C33.7599 30.31 37.2299 26.84 37.2299 26.84C33.0999 20.4 36.8999 15.61 36.8999 15.61C32.6099 9.66996 37.0699 3.71998 37.0699 3.71998C37.0699 3.71998 42.0799 -0.600015 45.9099 3.78998C45.9099 3.78998 49.8699 10.08 45.1099 15.65C45.1099 15.65 48.5099 20.73 43.8699 26.82C43.8699 26.82 47.0399 30.56 43.2299 36.71C43.2299 36.71 44.8099 43.8 40.3699 47.41L39.0399 47.65Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
